export default __webpack_public_path__ + "static/media/IUSDP_OLD.2c88d249.png";